import React from 'react';
import { useParams } from 'react-router-dom';

import ReflectionEntryForm from '../components/reflection/ReflectionEntryForm';

/**
 * Reflection Entry Page - Create/Edit reflection for a specific date
 * Route: /reflection/:date
 */
const ReflectionEntryPage = () => {
  const { date } = useParams();

  // Validate date format (YYYY-MM-DD)
  const isValidDate = (dateString) => {
    const regex = /^\d{4}-\d{2}-\d{2}$/;
    if (!regex.test(dateString)) return false;

    const d = new Date(dateString);
    return d instanceof Date && !isNaN(d);
  };

  if (!date || !isValidDate(date)) {
    return (
      <div className="reflection-entry-container">
        <div className="reflection-error">
          <i className="fa-solid fa-exclamation-triangle" /> Invalid date format. Please use
          YYYY-MM-DD format.
        </div>
      </div>
    );
  }

  return <ReflectionEntryForm date={date} />;
};

export default ReflectionEntryPage;
